import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./CajasDeslizantes.css";

interface Box {
  id: string;
  icono: string;
  fondo: string;
  ruta: string;
}

const boxes: Box[] = [
  {
    id: "desarrollo",
    icono: "/icons/codigo.png",
    fondo: "/Desarrollo.webp",
    ruta: "/Desarrollo",
  },
  {
    id: "migracion",
    icono: "/icons/migraciones.png",
    fondo: "/ImgMigraciones.webp",
    ruta: "/Migracion",
  },
  {
    id: "digitalizacion",
    icono: "/icons/digi.png",
    fondo: "/Digitalizacion.webp",
    ruta: "/Digitalizacion",
  },
  {
    id: "data",
    icono: "/icons/data.png",
    fondo: "/ImgData.webp",
    ruta: "/Data",
  },
  {
    id: "incident",
    icono: "/icons/incident.png",
    fondo: "/incidentmanagement.webp",
    ruta: "/Incident",
  },
  {
    id: "consultoria",
    icono: "/icons/consultoria.png",
    fondo: "/Consultoriaaa.webp",
    ruta: "/Consultoria",
  },
  { id: "ia", icono: "/icons/chip.png", fondo: "/9142834.webp", ruta: "/Ia" },
  {
    id: "staff",
    icono: "/icons/supply-chain.webp",
    fondo: "/postulate.webp",
    ruta: "/staffAugmentation",
  },
];

export default function CajasDeslizantes() {
  const { t } = useTranslation();

  return (
    <div className="cajas-grid">
      {boxes.map((box) => (
        <Link to={box.ruta} key={box.id} style={{ textDecoration: "none" }}>
          <div
            className="caja-simple"
            style={{ backgroundImage: `url(${box.fondo})` }}
          >
            <div className="caja-overlay">
              <div className="caja-icono">
                <img src={box.icono} alt={t(`nav.servicios_list.${box.id}`)} />
              </div>
              <div className="caja-titulo">
                {t(`nav.servicios_list.${box.id}`)}
              </div>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}
